// Utilitats per aplicar la penalització per intents fallits de forma DINÀMICA en el moment
// de mostrar la nota. La nota BASE (sense penalització) és la que es desa a la BD com a font
// de veritat; la penalització es calcula a partir del nombre d'intents fallits vigents, de
// manera que si s'elimina un enviament la nota mostrada s'actualitza a l'instant.

/**
 * Extreu la penalització per intent (punts a restar per cada intent fallit) de la
 * configuració de l'exercici. Admet:
 *  - test_config/customConfig com a objecte amb { penalitzacioPerIntent }
 *  - camp `checks` amb patró "PENALTY:<n>" o un JSON després d'un '#'
 */
export const getPenalitzacioPerIntent = (source: any): number => {
    if (source == null) return 0;

    // 1) Objecte de configuració directe
    if (typeof source === 'object') {
        if (typeof source.penalitzacioPerIntent !== 'undefined') {
            return Number(source.penalitzacioPerIntent) || 0;
        }
        if (source.test_config) return getPenalitzacioPerIntent(source.test_config);
        if (source.checks) return getPenalitzacioPerIntent(source.checks);
        return 0;
    }

    // 2) String: pot ser "PENALTY:5", o "...#{json}" o un JSON directe
    if (typeof source === 'string') {
        const s = source.trim();
        const m = s.match(/PENALTY:(\d+(?:\.\d+)?)/i);
        if (m) return Number(m[1]) || 0;
        let jsonPart = s;
        const hashIdx = s.indexOf('#');
        if (hashIdx !== -1 && s.slice(hashIdx + 1).trim().startsWith('{')) {
            jsonPart = s.slice(hashIdx + 1).trim();
        }
        if (jsonPart.startsWith('{')) {
            try {
                const parsed = JSON.parse(jsonPart);
                if (typeof parsed.penalitzacioPerIntent !== 'undefined') {
                    return Number(parsed.penalitzacioPerIntent) || 0;
                }
            } catch (_) { /* ignore */ }
        }
    }
    return 0;
};

/**
 * Aplica la penalització a una nota base.
 * @param notaBase nota 0-100 sense penalització (font de veritat)
 * @param intentsFallits nombre d'intents fallits PREVIS vigents
 * @param penalitzacioPerIntent punts a restar per cada intent fallit
 * @returns { notaFinal, penalitzacioTotal }
 */
export const aplicarPenalitzacio = (
    notaBase: number,
    intentsFallits: number,
    penalitzacioPerIntent: number
): { notaFinal: number; penalitzacioTotal: number } => {
    const base = Math.max(0, Math.min(100, Number(notaBase) || 0));
    const intents = Math.max(0, Number(intentsFallits) || 0);
    const perIntent = Math.max(0, Number(penalitzacioPerIntent) || 0);
    const penalitzacioTotal = Math.round(intents * perIntent);
    const notaFinal = Math.max(0, Math.min(100, Math.round(base - penalitzacioTotal)));
    return { notaFinal, penalitzacioTotal };
};
